import styled from "@emotion/styled";
import { NewsletterIcon } from "scmp-sdk/components/newsletter/newsletter-widget/newsletter-icon";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto } from "shared/lib/styles";

export const MessageContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  margin-block: 16px;
  margin-inline: 0;
`;

type MessageProps = {
  theme?: ThemeType;
};

export const Message = styled.div<MessageProps>`
  color: #000000;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  ${props => {
    switch (props.theme?.findOutMore?.titleFontStyle) {
      case "large":
        return `
          font-size: 21px;
          line-height: 27px;
        `;
    }
  }}
`;

export const StyledNewsletterIcon = styled(NewsletterIcon)`
  inline-size: 28px;
  block-size: 24px;
`;

export const Button = styled.a``;

export const ButtonContainer = styled.div`
  ${Button} {
    display: inline-block;

    inline-size: auto;

    color: #4585ff;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 16px;
    text-decoration: underline;

    cursor: pointer;
  }
`;

export const SummaryLine = styled.div`
  inline-size: 60px;
  block-size: 1px;
  margin-block-end: 28px;

  background-color: #001246;
`;

export const Container = styled.div`
  display: grid;
  grid-template-areas:
    "SummaryLine"
    "Icon"
    "Message"
    "Button";
  justify-items: center;

  text-align: center;
  ${StyledNewsletterIcon} {
    grid-area: Icon;
  }

  ${ButtonContainer} {
    grid-area: Button;
  }

  ${MessageContainer} {
    grid-area: Message;
  }

  ${SummaryLine} {
    grid-area: SummaryLine;
  }
`;
